import React from 'react';
import { Link } from 'react-router-dom';

export const VolTsunamiModal = {
  title: 'Tsunami',
  body: (
    <div>
      <p>
        A value would indicate that the volcano caused a tsunami. The link connects to the event associated with the eruption in
        {' '}
        <Link to="/view/hazards/tsunami/event-search" target="_blank" rel="noopener noreferrer">Global Tsunami Database.</Link>
      </p>
    </div>
  ),
};
